import classNames from 'classnames';
import { FC } from 'react';

import Text, { TextProps } from '../Text';

// Component Definition
const Heading5: FC<TextProps> = props => (
  <Text
    as="h5"
    fontSize="smallBody"
    fontWeight="bold"
    {...props}
    className={classNames(props.className, 'text_heading5')}
  />
);

export default Heading5;
